import React, { useContext } from 'react';
import { Navigate, useLocation, useParams } from '../utils/globalImports';
import { AuthContext } from '../utils/authContext';
import CreateInvoice from '../pages/Invoicing/CreateInvoice';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: string[];
}

 // Invoice Protected Route
export const InvoiceRouteGuard = () => {
  const { user } = useContext(AuthContext);
  const { mode } = useParams<{ mode: string }>();

  const validModes = ['view', 'edit'];

  if(mode && !validModes.includes(mode)){
    return <Navigate to="*" replace />;
  }

  if (user?.role.toLowerCase() === "smt" && mode === 'edit') {
    return <Navigate to="/unauthorized" replace />;
  }
  return <CreateInvoice />;
};



const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles }) => {
  const { isAuthenticated, user } = useContext(AuthContext);
  const location = useLocation();

  //console.log('ProtectedRoute: isAuthenticated:', isAuthenticated);
  // Check if the user is authenticated
  // Still loading authentication state
  if (isAuthenticated === null) {
    return null; 
  }

  // Not authenticated — redirect to login
  if (isAuthenticated === false) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && allowedRoles.length > 0 && !allowedRoles.includes(user?.role ?? '')) {
    return <Navigate to="/unauthorized" replace />;
  }
  

  // Authenticated — show protected content
  return <>{children}</>;
};

export default ProtectedRoute;

